import React from "react";
import { Alert, Card, Spinner, Table } from "react-bootstrap";
import { useTeacherHours } from "../hooks/useTeacherHours";
import dayjs from "dayjs";

const COP = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
});

function TeacherHoursPage() {
  const { data, isLoading, error } = useTeacherHours();

  return (
    <div className="container-fluid px-3">
      <div className="py-3">
        <h1 className="h4 mb-0">Mis horas</h1>
          <p className="text-muted small mb-0">
            Acumulado pendiente de liquidación
          </p>
        </div>

        {/* TASK-11/15 stub notice — shown only when endpoint is unavailable */}
        {error?.response?.status === 404 && (
          <Alert variant="info" className="mb-3">
            El resumen de horas estará disponible cuando se integre el backend
            (TASK-11 / TASK-15 pendiente).
          </Alert>
        )}

        {error && error?.response?.status !== 404 && (
          <Alert variant="danger">No se pudo cargar el resumen de horas.</Alert>
        )}

        {isLoading && (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
          </div>
        )}

        {data && (
          <>
            {/* Summary cards */}
            <div className="row g-3 mb-4">
              <div className="col-6">
                <Card className="text-center h-100">
                  <Card.Body>
                    <p className="text-muted small mb-1">Horas pendientes</p>
                    <h2 className="h3 mb-0">{data.hours_pending ?? 0}</h2>
                    <small className="text-muted">horas</small>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-6">
                <Card className="text-center h-100">
                  <Card.Body>
                    <p className="text-muted small mb-1">Estimado a cobrar</p>
                    <h2 className="h3 mb-0 text-success">
                      {data.estimated_amount != null
                        ? COP.format(data.estimated_amount)
                        : "—"}
                    </h2>
                    {data.rate_applied && (
                      <small className="text-muted">
                        a {COP.format(data.rate_applied)}/h
                      </small>
                    )}
                  </Card.Body>
                </Card>
              </div>
            </div>

            {/* Payment history */}
            {data.hours_paid_history?.length > 0 && (
              <Card>
                <Card.Header>
                  <strong>Histórico de liquidaciones</strong>
                </Card.Header>
                <div className="table-responsive">
                  <Table className="mb-0" size="sm">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th className="text-end">Horas</th>
                        <th className="text-end">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.hours_paid_history.map((entry, i) => (
                        <tr key={i}>
                          <td>{dayjs(entry.date).format("D MMM YYYY")}</td>
                          <td className="text-end">{entry.hours}</td>
                          <td className="text-end">{COP.format(entry.amount)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
            )}
          </>
        )}
      </div>
  );
}

export { TeacherHoursPage };
